import { render } from "./Zipper.vue?vue&type=template&id=c06f95de&scoped=true"
const script = {}

import "./Zipper.vue?vue&type=style&index=0&id=c06f95de&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c06f95de"

export default script